import { render, staticRenderFns } from "./dichiarazioni.vue?vue&type=template&id=57104999&scoped=true&"
import script from "./dichiarazioni.vue.ts?vue&type=script&lang=ts&"
export * from "./dichiarazioni.vue.ts?vue&type=script&lang=ts&"
import style0 from "./dichiarazioni.vue?vue&type=style&index=0&id=57104999&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57104999",
  null
  
)

export default component.exports